var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.role && _vm.role.length > 0
      ? _c(
          "ul",
          { class: ["sm-cast", _vm.showAllContent ? "show" : ""] },
          _vm._l(_vm.role, function (value, i) {
            return _c("li", { key: i }, [
              _c(
                "a",
                {
                  attrs: {
                    href:
                      "/star?query=" +
                      encodeURIComponent(value.star) +
                      "&spver=" +
                      _vm.spver,
                    uigs: "cast_image_",
                    "+value.star": "",
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      src: _vm.$parent.getResizePicUrl(
                        value.image,
                        80,
                        "auto",
                        200839
                      ),
                    },
                  }),
                  _vm._v(" "),
                  _c("h3", [_vm._v(_vm._s(value.star))]),
                  _vm._v(" "),
                  value.cate && value.role
                    ? _c("p", [
                        _vm._v(
                          _vm._s(_vm.cate(value.cate)) +
                            "（饰 " +
                            _vm._s(value.role) +
                            "）"
                        ),
                      ])
                    : value.cate && !value.role
                    ? _c("p", [_vm._v(_vm._s(_vm.cate(value.cate)))])
                    : !value.cate && value.role
                    ? _c("p", [_vm._v("饰 " + _vm._s(value.role))])
                    : _vm._e(),
                ]
              ),
            ])
          }),
          0
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.role.length >= 3,
            expression: "role.length >= 3",
          },
        ],
        class: ["sm-cast-show", _vm.showAllContent ? "hide" : ""],
        on: { click: _vm.showContent },
      },
      [_c("span", [_vm._v("展开更多")])]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }